import { useState, useEffect } from 'react'
import { PageTitle } from 'components/common/PageTitle'
import s from './TimeTracking.scss'
import { isTimetrackerAdmin, isTimetrackerRegular } from 'utils/authService'
import { Tabs } from 'components/ideal-core-ui'
import { TimeTrackerCalendar } from './Calendar'
import { TimeTrackerList } from './List'
import { Reports } from './Reports'
import qs from 'query-string'
import { useLocation } from 'react-router'
import { makeGetRequest } from 'utils/api'
import moment from 'moment'

const getWeekDays = weekStart => {
  const days = [weekStart]
  for (let i = 1; i < 7; i += 1) {
    days.push(moment(weekStart).add(i, 'days').toDate())
  }
  return days
}

const getCurrentWeekDays = () => {
  const weekStart = moment().startOf('week').toDate()
  return getWeekDays(weekStart)
}

const TimeTracking = () => {
  const location = useLocation()
  const { tab } = qs.parse(location.search)
  const [settings, setSettings] = useState({})
  const [selectedWeek, setSelectedWeek] = useState([])

  useEffect(() => {
    ;(async () => {
      const settingsResponse = await makeGetRequest('/v1/timetracker/settings')
      setSettings(settingsResponse)

      moment.updateLocale('en', {
        week: {
          dow: settingsResponse.weekStart === 'MONDAY' ? 1 : 0
        }
      })

      setSelectedWeek(getCurrentWeekDays)
    })()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleWeekChange = week => {
    setSelectedWeek(getWeekDays(week.from))
  }

  return (
    <>
      <PageTitle view="Time Tracker" />
      <section className={s.container}>
        {isTimetrackerAdmin() || isTimetrackerRegular() ? (
          <Tabs
            className={s.tabsWrapper}
            withUpdateUrl
            contentClassName={s.contentClassName}
            activeTabKey={tab || 'calendar'}
            tabs={[
              {
                key: 'calendar',
                label: 'Calendar',
                value: (
                  <TimeTrackerCalendar
                    settings={settings}
                    selectedWeek={selectedWeek}
                    setSelectedWeek={setSelectedWeek}
                    handleWeekChange={handleWeekChange}
                  />
                )
              },
              {
                key: 'batch',
                label: 'Batch',
                value: (
                  <TimeTrackerList
                    settings={settings}
                    selectedWeek={selectedWeek}
                    setSelectedWeek={setSelectedWeek}
                    handleWeekChange={handleWeekChange}
                  />
                )
              },
              {
                key: 'reports',
                label: 'Reports',
                value: <Reports />
              }
            ]}
          />
        ) : (
          <h5 className={s.noAccess}>
            You need to enable Time Tracker module to access this page. Please contact your manager.
          </h5>
        )}
      </section>
    </>
  )
}

export default TimeTracking
